var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.375C9.93586 3.375 3.375 9.93586 3.375 18C3.375 26.0641 9.93586 32.625 18 32.625C26.0641 32.625 32.625 26.0641 32.625 18C32.625 9.93586 26.0641 3.375 18 3.375ZM15.3281 25.3392L9.66094 19.0413L11.3337 17.5359L15.2712 21.9108L24.6094 10.7902L26.3348 12.2344L15.3281 25.3392Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkCircle);
export default __webpack_public_path__ + "static/media/CheckMarkCircle.c04cda083f180046ad0fbd6a61c82a75.svg";
export { ForwardRef as ReactComponent };